import {componentHandler} from './materialDesignLite';
import {Directive, OnInit, OnDestroy} from '@angular/core';
import {Router} from '@angular/router';

import {Subscription} from 'rxjs';

@Directive({
    selector: '[mdlOnRouteChange]'
})
export class MdlOnRouteChange implements OnInit, OnDestroy {
    private querySubscription: Subscription;

    constructor(private router: Router) {
    }

    public ngOnInit() {
        console.debug('mdl-router-watcher initialized');
        this.querySubscription = this.router
            .events
            .subscribe(() => {
                componentHandler.upgradeDom();
            });
    }

    public ngOnDestroy() {
        console.debug('mdl-router-watcher disposed');
        this.querySubscription.unsubscribe();
    }
}